import React from 'react'

import SingleTeam from '../components/Public/FootballAPI/Team/SingleTeam'

function SingleTeamAPIPage() {
    return (
        <SingleTeam/>
    )
}
export default SingleTeamAPIPage